import { useMemo } from 'react';
import { useGetOrderQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { MlkAction } from '../../models';
import { useIsEditDoorbellPositionEnabled } from './useIsEditDoorbellPositionEnabled';
import { useIsAppointmentEnabled } from './useIsAppointmentEnabled';
import { useIsEditAddressEnabled } from './useIsEditAddressEnabled';
import { useIsEditNotesEnabled } from './useIsEditNotesEnabled';
import { useIsEditReviewEnabled } from './useIsEditReviewEnabled';
import { useIsPdrEnabled } from './useIsPdrEnabled';
import { useIsReceptionEnabled } from './useIsReceptionEnabled';
import { useIsReviewEnabled } from './useIsReviewEnabled';
import { useOrderId } from '../useOrderId';
import { useIsNoAssign } from '../useIsNoAssign';

export const useMlkActions = (): MlkAction[] | null => {
  const orderId = useOrderId();
  const isNoAssign = useIsNoAssign();

  const { data: order } = useGetOrderQuery(
    { orderId: orderId || '', isNoAssign },
    {
      skip: !orderId,
    }
  );

  const isAppointmentAvailable = useIsAppointmentEnabled();
  const isPrdAvailable = useIsPdrEnabled();
  const isReceptionAvailable = useIsReceptionEnabled();
  const isEditAddressAvailable = useIsEditAddressEnabled();
  const isEditNotesAvailable = useIsEditNotesEnabled();
  const isEditDoorbellPositionAvailable = useIsEditDoorbellPositionEnabled();
  const isReviewAvailable = useIsReviewEnabled();
  const isEditReviewAvailable = useIsEditReviewEnabled();

  const availableActions = useMemo(() => {
    if (isNoAssign) return [];

    const actions = [];

    if (isAppointmentAvailable) actions.push(MlkAction.Appointment);
    if (isPrdAvailable) actions.push(MlkAction.Pdr);
    if (isReceptionAvailable) actions.push(MlkAction.Reception);
    if (isEditAddressAvailable) actions.push(MlkAction.EditAddress);
    if (isEditNotesAvailable) actions.push(MlkAction.EditNotes);
    if (isEditReviewAvailable) actions.push(MlkAction.EditReview);
    if (isReviewAvailable) actions.push(MlkAction.Review);
    if (isEditDoorbellPositionAvailable)
      actions.push(MlkAction.EditDoorbellPosition);

    return actions;
  }, [
    isAppointmentAvailable,
    isEditAddressAvailable,
    isEditDoorbellPositionAvailable,
    isEditNotesAvailable,
    isEditReviewAvailable,
    isNoAssign,
    isPrdAvailable,
    isReceptionAvailable,
    isReviewAvailable,
  ]);

  if (!order) return null;

  return availableActions;
};
